import { dev } from '$app/environment';

export async function getPrices(productId: string, priceIds: string[], country?: string) {
  const baseUrl = dev ? 'http://localhost:8888' : '';
  const endpoint = '/.netlify/functions/prices';
  const params = new URLSearchParams();
  params.set('productId', productId);
  params.set('priceIds', priceIds.join(','));
  if (country) params.set('country', country);

  // Netlify functions are hosted on same domain as the client in production
  const response = await fetch(`${baseUrl}${endpoint}?${params.toString()}`, {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error('Failed to fetch prices');
  }

  const data = response.json();
  return data;
}
